// extracted by mini-css-extract-plugin
export default {"errorWrapper":"errorWrapper--axRaP"};